enum Action {
  SET_FILTERS = 'setFilters',
}

export default Action;
